import { createAction } from 'redux-actions';
import { store } from 'store/createStore';
import _ from 'lodash';

import { formatDateAndTime } from '../../../../utils/time';
import API from '../../../../utils/api';

export const loading = createAction('@@users/loading');

export const setShowAnonymousUsers = createAction(
  '@@users/setShowAnonymousUsers',
  data => dispatch => {
    return data;
  }
);

export const createCondition = createAction(
  '@@users/createCondition',
  (field, operator, value, question, date, picks) => async dispatch => {
    dispatch(loading());
    const newContition = {
      field: field,
      operator: operator,
      value: value,
      question: question,
      date: date,
      picks: picks,
    };

    if (field === 'Channel') {
      const channelId = value._id;
      if (channelId) {
        dispatch(fetchListChannelEvents(channelId));
      }
    } else if (field === 'Event') {
      const eventId = value._id;
      if (eventId) {
        dispatch(fetchInteraction(eventId));
      }
    }
    return newContition;
  }
);

export const deleteCondition = createAction(
  '@@users/deleteCondition',
  index => dispatch => {
    dispatch(loading());
    let indexToRemove = -1;
    if (index >= 0) {
      indexToRemove = index;
    }
    return indexToRemove;
  }
);

export const fetchInteractionData = createAction(
  '@@users/fetchInteractionData',
  interactionId => async dispatch => {
    dispatch(loading());
    const { currentGroup } = store.getState().auth;
    let query = {
      docType: `^interaction_[a-zA-Z]*`,
    };
    query['data.interaction.id'] = interactionId;

    query = JSON.stringify(query);

    const leads = await API.getLeads({
      group: currentGroup._id,
      query: query,
    });

    const distictData = [...new Set(leads.map(el => el.data.user))];

    dispatch(fetchUsersInteraction(distictData));
    dispatch(fetchFilterInteractionStatistics(interactionId));

    return {
      listData: leads,
      listUsersWithData: distictData,
    };
  }
);

export const fetchEventData = createAction(
  '@@users/fetchEventData',
  event => async dispatch => {
    dispatch(loading());
    const { currentGroup } = store.getState().auth;
    let query = {
      docType: `^interaction_[a-zA-Z]*`,
    };
    query['data.channelEvent.id'] = event._id;

    query = JSON.stringify(query);

    const leads = await API.getLeads({
      group: currentGroup._id,
      query: query,
    });

    const distictData = [...new Set(leads.map(el => el.data.user))];

    await dispatch(fetchUsersInteraction(distictData));
    await dispatch(fetchFilterEventStatistics(event._id));

    return {
      listData: leads,
      listUsersWithData: distictData,
      event: event,
    };
  }
);

export const fetchFilterData = createAction(
  '@@users/fetchFilterData',
  query => async dispatch => {
    dispatch(loading());

    const { currentGroup } = store.getState().auth;
    query['docType'] = `^interaction_[a-zA-Z]*`;

    query = JSON.stringify(query);

    const leads = await API.getLeads({
      group: currentGroup._id,
      query: query,
    });

    const distictData = [...new Set(leads.map(el => el.data.user))];

    dispatch(fetchUsersInteraction(distictData));

    return {
      listData: leads,
      listUsersWithData: distictData,
    };
  }
);

export const combineConditions = createAction(
  '@@users/combineConditions',
  listConditions => async dispatch => {
    dispatch(loading());
    let query = {};
    let interactionId = {};
    const condSize = listConditions.length;
    const condition = listConditions[condSize - 1];
    if (condSize === 0) {
      await dispatch(fetchUsersInteraction());
    } else if (condition.field === 'Channel') {
      await dispatch(fetchUsersInteraction());
    } else if (condition.field === 'Event') {
      const event = condition.value;
      await dispatch(fetchEventData(event));
    } else if (condition.field === 'Interaction') {
      interactionId = condition.value._id;
      await dispatch(fetchInteractionData(interactionId));
    } else if (condition.field === 'Question') {
      interactionId = listConditions[condSize - 2].value._id;
      query = {
        'data.params.question.index': condition.question.index,
        'data.params.answer.index': condition.value.index,
      };
      query['data.interaction.id'] = interactionId;
      await dispatch(fetchFilterData(query));
    }

    return null;
  }
);

export const fetchInteraction = createAction(
  '@@users/fetchInteraction',
  eventId => dispatch => {
    dispatch(loading());

    return API.getInteractions({ query: JSON.stringify({ event: eventId }) }).then(
      ({ data }) => data
    );
  }
);

export const createReport = createAction('@@users/createReport', event => dispatch => {});

export const fetchListQuestions = createAction(
  '@@users/fetchListQuestions',
  interactionId => dispatch => {
    dispatch(loading());

    return API.getInteractions({ query: JSON.stringify({ _id: interactionId }) }).then(
      ({ data }) => data
    );
  }
);

export const fetchUsersInteraction = createAction(
  '@@users/fetchUsersInteraction',
  (listUsersWithData, from, to, userAnonymous, hideDeletedUsers) => dispatch => {
    dispatch(loading());

    return API.getUserInteractions({
      users: listUsersWithData,
      from,
      to,
      userAnonymous,
      hideDeletedUsers,
    }).then(({ data }) => data || []);
  }
);

export const fetchListChannels = createAction(
  '@@users/fetchListChannels',
  () => dispatch => {
    dispatch(loading());
    return API.getChannels().then(({ data }) => data);
  }
);

export const fetchListChannelEvents = createAction(
  '@@users/fetchListChannelEvents',
  channelId => dispatch => {
    dispatch(loading());

    return API.getChannelEvents({
      query: JSON.stringify({ channel: channelId }),
      global: true,
    }).then(({ data }) => data);
  }
);

export const fetchFilterEventStatistics = createAction(
  '@@users/fetchFilterEventStatistics',
  eventId => async dispatch => {
    dispatch(loading());
    const { currentGroup } = store.getState().auth;

    const answer = await API.getEventStatistics(eventId, {
      group: currentGroup._id,
    });

    return answer;
  }
);

export const fetchFilterInteractionStatistics = createAction(
  '@@users/fetchFilterInteractionStatistics',
  interactionId => async dispatch => {
    dispatch(loading());

    const { data } = await API.getInteractionStatistics({
      interaction: interactionId,
    });

    return data;
  }
);

export const fetchUpdateDataAnalytics = createAction(
  '@@users/fetchUpdateDataAnalytics',
  () => dispatch => {
    dispatch(loading());
    dispatch(fetchUsersInteraction());
    dispatch(fetchListChannels());

    return null;
  }
);

export const filterOption = createAction(
  '@@users/filterOption',
  (interaction, question, option, preview) => dispatch => {
    dispatch(
      createCondition(
        'Question',
        null,
        { name: option.title, index: option.index },
        { name: question.questionTitle, index: question.questionIdx },
        null,
        null
      )
    );
    return null;
  }
);

export const rowInteractionAction = createAction(
  '@@users/rowInteractionAction',
  interaction => dispatch => {
    dispatch(createCondition('Interaction', 'is', interaction, null, null, null));
    return null;
  }
);

export const updateListPredicates = createAction(
  '@@users/updateListPredicates',
  setence => dispatch => {
    dispatch(loading());

    let listPredicates = [];

    const field = _.get(setence, 'field.name', null);
    if (field === 'Interaction') {
      const { listInteractions } = store.getState().analytics;
      const parseListInteractions = listInteractions.map(interaction => {
        return {
          name: interaction.name + ' - ' + formatDateAndTime(interaction.publishedAt),
          value: interaction.name,
          date: interaction.publishedAt,
          _id: interaction._id,
          type: interaction.type,
        };
      });
      listPredicates = parseListInteractions;
    } else if (field === 'Channel') {
      const { listChannels } = store.getState().analytics;

      listPredicates = listChannels;
    } else if (field === 'Event') {
      const { listChannelEvents } = store.getState().analytics;
      listPredicates = listChannelEvents;
    }

    return listPredicates;
  }
);
